import React from "react";
import PropTypes from "prop-types";
import MainLayout from "./main-layout";
import "@fontsource/cooper-hewitt/100.css";
import "@fontsource/cooper-hewitt/200.css";
import "@fontsource/cooper-hewitt/300.css";
import "@fontsource/cooper-hewitt/400.css";
import "@fontsource/cooper-hewitt/500.css";
import "@fontsource/cooper-hewitt/600.css";
import "@fontsource/cooper-hewitt/700.css";
import "@fontsource/cooper-hewitt/800.css";

const Layout = ({ children, pageContext }) => {
  switch (pageContext.layout) {
    default:
      return <MainLayout {...pageContext}>{children}</MainLayout>;
  }
};

Layout.propTypes = {
  children: PropTypes.any,
  pageContext: PropTypes.any,
};

export default Layout;
